"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowMarkDownEditorBase = void 0;
const Entities_1 = require("../../Entities");
class ShowMarkDownEditorBase extends Entities_1.RequestHandler {
    castPayloadV1(payload) {
        const castPayload = payload;
        if (castPayload.initialText === undefined || castPayload.submitCallback === undefined) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 1, JSON.stringify(payload));
        }
        return castPayload;
    }
    constructor(hostHandler) {
        super();
        this.requestType = 'SHOW_MARKDOWN_EDITOR';
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version, payload) => {
            if (version === 1) {
                const castPayload = this.castPayloadV1(payload);
                this.action(castPayload);
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.ShowMarkDownEditorBase = ShowMarkDownEditorBase;
